module.exports = __webpack_public_path__ + "static/img/img_logo.f76c47e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_logo.png
// module id = PcyW
// module chunks = 1